import { Luscinia, luscinia } from "./luscinia";
import { DynamicModal } from "./modal/DynamicModal";

// Shows confirmation modal dialog
// TODO: Add custom button captions, Yes/No for now
luscinia.showConfirmationDialog = function (title, text, callback) {
    DynamicModal.CreateModalDialog();
    var dialog = luscinia.confirmDialog;
    $(dialog.identifier.title).text(title);
    if (luscinia.isHTML(text)) {
        $(dialog.identifier.text).html(text);
    }
    else {
        $(dialog.identifier.text).text(text);
    }
    $("#dialogModalYes").unbind("click");
    $("#dialogModalYes").on('click', callback);
    $(dialog.identifier.modal).modal("show");

    luscinia.UpdateModalZIndex(dialog);
};

luscinia.showConfirmationDialogWithExtraInput = function (title, text, callback) {
    var dialog = luscinia.confirmDialog;

    // Set title and text
    $(dialog.identifier.title).text(title);
    if (luscinia.isHTML(text)) {
        $(dialog.identifier.text).html(text);
    }
    else {
        $(dialog.identifier.text).text(text);
    }

    // Append the input field
    var inputHTML = '<input class="form-control" type="text" id="customInput" placeholder="Enter value here...">';
    $(dialog.identifier.text).append(inputHTML);

    // Modify the button click to capture input value and pass to callback
    $("." + dialog.css.dialogButton).off("click");
    $("." + dialog.css.dialogButton).on('click', () => {
        var inputValue = $("#customInput").val().toString();
        callback(inputValue);
    });

    // Show the modal
    $(dialog.identifier.modal).modal("show");

    luscinia.UpdateModalZIndex(dialog);
};


luscinia.showConfirmationDialogApplyIfAccepted = function (title, text, callback) {
    var dialog = luscinia.confirmDialog;
    $(dialog.identifier.title).text(title);
    if (luscinia.isHTML(text)) {
        $(dialog.identifier.text).html(text);
    } else {
        $(dialog.identifier.text).text(text);
    }
    $('.' + dialog.css.dialogButton).unbind('click');
    $('#dialogModalYes').on('click', callback);
    $(dialog.identifier.modal).modal('show');
    
    luscinia.UpdateModalZIndex(dialog);
};

luscinia.UpdateModalZIndex = function (dialog: { identifier: { modal: string; modalWarning: string; title: string; text: string; modalBackdropClass: string; }; css: { dialogButton: string; }; }) {
    var currentZIndex = $(dialog.identifier.modal).css("z-index");
    var modalBackDrop = $(dialog.identifier.modalBackdropClass).first();
    if(modalBackDrop.length === 1){
        var modalBackDropZIndex = modalBackDrop.css("z-index");
        if(currentZIndex < modalBackDropZIndex){
            currentZIndex = modalBackDropZIndex + 1;
        }
    }

    var modals = $(document).find(".edit-modal") as unknown as JQuery<HTMLElement>;
    var highestZIndex = currentZIndex;
    modals.each(function (index, element) {
        var modalZIndex = $(element).css("z-index");
        if (modalZIndex > highestZIndex) {
            highestZIndex = modalZIndex;
        }
    });

    var warningModal = $(dialog.identifier.modalWarning).first();
    if(warningModal.length === 1) {
        warningModal.css("z-index", highestZIndex + 1);
        $(dialog.identifier.modal).css("z-index", highestZIndex + 2);
    }
    else{
        $(dialog.identifier.modal).css("z-index", highestZIndex + 1);
    }
}
